// Angular
import { Component, EventEmitter, Input, Output } from '@angular/core';
// models
import { ModalMode } from 'src/app/models';

@Component({
    selector: 'app-modal-title',
    templateUrl: './modal-title.component.html',
    styleUrls: ['./modal-title.component.scss'],
    standalone: false
})
export class ModalTitleComponent {
    @Input() isActivatable: boolean = false;
    @Input() isAdmin: boolean = false;
    @Input() isArchived: boolean = false;
    @Input() isArchivable: boolean = false;
    @Input() isDeletable: boolean = false;
    @Input() isDuplicable: boolean = false;
    @Input() isEditable: boolean = true;
    @Input() mode: ModalMode = ModalMode.DETAIL;
    @Input() showEditButtons: boolean = true;
    @Input() showSendInvitationButton: boolean = false;
    @Input() showSendStartLink: boolean = false;
    @Input() submitting: boolean = false;
    @Input() tile: string = '';
    @Input() tileClass: 'primary-tile' | 'success-tile-light' | 'success-tile-dark' | 'error-tile' | 'gray-tile' =
        'gray-tile';
    @Input() title: string = '';

    @Output() activateClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() archiveClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() cancelClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() deleteClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() duplicateClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() editClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() saveClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() sendStartLink: EventEmitter<void> = new EventEmitter<void>();

    ModalMode = ModalMode;

    onEditClicked(): void {
        this.editClicked.emit();
    }

    onCancelClicked(): void {
        this.cancelClicked.emit();
    }

    onSaveClicked(): void {
        this.saveClicked.emit();
    }

    onDeleteClicked(): void {
        this.deleteClicked.emit();
    }

    onArchiveClicked(): void {
        this.archiveClicked.emit();
    }

    onDuplicateClicked(): void {
        this.duplicateClicked.emit();
    }

    onActivateClicked(): void {
        this.activateClicked.emit();
    }

    onSendStartLinkClicked(): void {
        this.sendStartLink.emit();
    }
}
